import * as Types from '../types'
import { faSquareFull } from '@fortawesome/free-solid-svg-icons'

const initialState = {
  caja: {},
  aperturaCaja: {},
  estadisticas: [],
  loadingCaja: false,
  loadingEstadisticas: false,
  showModalCaja: false,
  showModalCorteZ: false,
  loadingCajas: false,
  cajas: []
}

export default function (state = initialState, action) {
  switch (action.type) {
    case Types.LISTA_CAJAS:
      return {
        ...state,
        loadingCajas: true,
        cajas: []
      }
    case Types.LISTA_CAJAS_EXITO:
      return {
        ...state,
        loadingCajas: false,
        cajas: action.payload
      }
    case Types.LISTA_CAJAS_ERROR:
      return {
        ...state,
        loadingCajas: false,
        error: action.payload
      }
    case Types.CAJA_DATOS_GENERALES:
      return {
        ...state,
        loadingCaja: true
      }
    case Types.CAJA_DATOS_GENERALES_EXITO:
      return {
        ...state,
        loadingCaja: false,
        aperturaCaja: action.payload
      }
    case Types.CAJA_DATOS_GENERALES_ERROR:
      return {
        ...state,
        loadingCaja: false,
        error: action.payload
      }

    case Types.CAJA_ESTADISTICAS:
      return {
        ...state,
        loadingEstadisticas: true
      }
    case Types.CAJA_ESTADISTICAS_EXITO:
      return {
        ...state,
        loadingEstadisticas: false,
        estadisticas: [
          {
            id: 1,
            label: 'Monto inicial',
            value: action.payload.montoInicial,
            color: 'secondary',
            icon: faSquareFull
          },
          {
            id: 2,
            label: 'Ingresos',
            value: action.payload.ingresos,
            color: 'primary',
            icon: faSquareFull
          },
          {
            id: 3,
            label: 'Gastos',
            value: action.payload.gastos,
            color: 'tertiary',
            icon: faSquareFull
          }
        ]
      }
    case Types.CAJA_ESTADISTICAS_ERROR:
      return {
        ...state,
        loadingEstadisticas: false,
        error: action.payload
      }
    case Types.MODAL_CAJA_APERTURA_CIERRE:
      return {
        ...state,
        showModalCaja: action.payload,
      }
    case Types.CAJA_CIERRE_EXITO:
      return {
        ...state,
        showModalCaja: false,
        aperturaCaja: action.payload
      }
    case Types.CAJA_APERTURA_EXITO:
      return {
        ...state,
        showModalCaja: false,
        aperturaCaja: action.payload
      }
    case Types.MODAL_CAJA_CORTE_Z:
      return {
        ...state,
        showModalCorteZ: action.payload,
      }
    case Types.CAMBIAR_CAJA:
      return {
        ...state,
        caja: action.payload
      }
    default:
      return state
  }
}
